const styles = `:host(.top) ::slotted(.tooltip) {
  margin-bottom: 0.5rem;
}
:host(.top) ::slotted(.tooltip)::before {
  border-top-color: transparent;
}
:host(.top) ::slotted(.tooltip)::after {
  border-top-color: var(--goto-neutral);
}
:host(.top) ::slotted(.tooltip)::before {
  bottom: -8px;
}
:host(.top) ::slotted(.tooltip)::after {
  bottom: -6px;
}
:host(.top) ::slotted(.tooltip)::before {
  left: calc(50% - 7px);
}
:host(.top) ::slotted(.tooltip)::after {
  left: calc(50% - 7px);
}

:host(.bottom) ::slotted(.tooltip) {
  margin-top: 0.5rem;
}
:host(.bottom) ::slotted(.tooltip)::before {
  border-bottom-color: transparent;
}
:host(.bottom) ::slotted(.tooltip)::after {
  border-bottom-color: var(--goto-neutral);
}
:host(.bottom) ::slotted(.tooltip)::before {
  top: -8px;
}
:host(.bottom) ::slotted(.tooltip)::after {
  top: -6px;
}
:host(.bottom) ::slotted(.tooltip)::before {
  left: calc(50% - 8px);
}
:host(.bottom) ::slotted(.tooltip)::after {
  left: calc(50% - 7px);
}

:host(.left) ::slotted(.tooltip) {
  margin-right: 0.5rem;
}
:host(.left) ::slotted(.tooltip)::before {
  border-left-color: transparent;
}
:host(.left) ::slotted(.tooltip)::after {
  border-left-color: var(--goto-neutral);
}
:host(.left) ::slotted(.tooltip)::before {
  top: calc(50% - 8px);
}
:host(.left) ::slotted(.tooltip)::after {
  top: calc(50% - 7px);
}
:host(.left) ::slotted(.tooltip)::before {
  right: -8px;
}
:host(.left) ::slotted(.tooltip)::after {
  right: -6px;
}

:host(.right) ::slotted(.tooltip) {
  margin-left: 0.5rem;
}
:host(.right) ::slotted(.tooltip)::before {
  border-right-color: transparent;
}
:host(.right) ::slotted(.tooltip)::after {
  border-right-color: var(--goto-neutral);
}
:host(.right) ::slotted(.tooltip)::before {
  top: calc(50% - 8px);
}
:host(.right) ::slotted(.tooltip)::after {
  top: calc(50% - 7px);
}
:host(.right) ::slotted(.tooltip)::before {
  left: -8px;
}
:host(.right) ::slotted(.tooltip)::after {
  left: -6px;
}

::slotted(.tooltip) {
  display: inline-flex;
  border-radius: 4px;
  font: var(--goto-caption-default-01);
  color: var(--goto-text-04);
  background-color: var(--goto-neutral);
  padding: 6px 8px;
}
::slotted(.tooltip)::before, ::slotted(.tooltip)::after {
  border-color: transparent;
  content: "";
  display: inline-block;
  position: absolute;
  border-style: solid;
  border-width: 1px;
  pointer-events: none;
}
::slotted(.tooltip)::before {
  border-width: 8px;
}
::slotted(.tooltip)::after {
  border-width: 7px;
}`; export default styles;